import { useCallback, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";

import { disableInitialLoading } from "src/redux/slices/global";

const useGlobalLoading = () => {
  const loading = useSelector(store => store.global?.initialLoading);
  const dispatch = useDispatch();

  const disableLoading = useCallback(() => {
    dispatch(disableInitialLoading());
  }, [dispatch]);

  // Memoize the return value to prevent unnecessary re-renders
  return useMemo(() => ({
    loading,
    disableLoading
  }), [loading, disableLoading]);
};

export default useGlobalLoading;
